(function() {
    'use strict';
 
 a3_cabin_reports.controller('RequestInstructionsCtrl',RequestInstructionsCtrl);

    /**
    * @memberof PilotReports
    * @ngdoc controller
    * @name RequestInstructionsCtrl
    * @description 
    *   Get the Roster Request Instructions
    * @ngInject
    */
function RequestInstructionsCtrl($scope, $uibModalInstance){
		$scope.page = 1;
		$scope.cancel = cancel;
        $scope.nextPage = nextPage;
        $scope.previousPage = previousPage;
    
        $scope.instructionPages = 1;
    
        /**
         * Goes to the next page of  leave instructions
         * @memberof RequestInstructionsCtrl
         */
        function nextPage(){
           $scope.page = $scope.page + 1;
           normalizePage();
        }
        
         /**
         * Goes to the previous page of leave instructions
         * @memberof RequestInstructionsCtrl
         */
        function previousPage(){
             $scope.page = $scope.page - 1;
             normalizePage();
        }
        
        /**
         * Normalize the page number if it is out of range
         * @memberof RequestInstructionsCtrl
         */
        function normalizePage(){
            if($scope.page > $scope.instructionPages || $scope.page<1){
                $scope.page = 1;
           }
        }
        /**
         * Close the modal
         * @memberof RequestInstructionsCtrl
         */
		function cancel() {
			$uibModalInstance.close('close');
		};
		
	}
 })();   